module.exports = __webpack_public_path__ + "static/media/plan-mas-400-gigas.770a1f10.svg";